import { injectIntl } from 'react-intl';
import BncRecaptcha from './BncRecaptcha';

export default injectIntl(BncRecaptcha, { withRef: true });
